import{useContext as e}from"react";import{AlertsRenderContext as r}from"../components/Alert/index.es.js";const t=()=>({showAlert:e(r).showAlert,hideAlert:e(r).hideAlert});export{t as useAlert};
